"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSkillCertificationSchema = exports.CandidateLanguageSkillSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const candidate_enum_1 = require("./candidate.enum");
exports.CandidateLanguageSkillSchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    candidateId: shared_1.UUIDSchema,
    languageId: shared_1.UUIDSchema,
    communication: candidate_enum_1.ProficiencyEnum,
    reading: candidate_enum_1.ProficiencyEnum,
    writing: candidate_enum_1.ProficiencyEnum,
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
exports.LanguageSkillCertificationSchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    certificationId: shared_1.UUIDSchema,
    languageSkillId: shared_1.UUIDSchema,
    score: zod_1.default.string().nullable(),
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
